// extracted by mini-css-extract-plugin
module.exports = {"red":"#e31818","backgroundGrey":"#EAEAEA","lightGrey":"#D5D5D5","grey":"#868686","darkGrey":"#585856","bordeaux":"#821423","blue":"#34A2CD","mint":"#57B695","small":"500","wrapper":"src-components-MarkerOnMapShape--wrapper","shapeWrapper":"src-components-MarkerOnMapShape--shapeWrapper","isInBerlin":"src-components-MarkerOnMapShape--isInBerlin","marker":"src-components-MarkerOnMapShape--marker"};
    if(module.hot) {
      // 1590940332305
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  